import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Star, Quote } from "lucide-react";
import { useReveal } from "@/lib/useReveal";

const testimonials = [
  {
    id: "q1",
    quote:
      "I finally stopped guessing. The dashboard shows exactly what&rsquo;s working — I hit a 20kg bench PR in 8 weeks.",
    name: "Jordan M.",
    tag: "Bench +20kg in 8 wks",
    accent: "lime",
  },
  {
    id: "q2",
    quote:
      "Zone 2 finally clicked. The plan adjusted on the fly and I ran my first sub-45 10K without crushing recovery.",
    name: "Priya S.",
    tag: "10K — 44:12",
    accent: "cyan",
  },
  {
    id: "q3",
    quote:
      "Coach feedback inside 24 hours is the difference. My squat depth fixed itself in two sessions.",
    name: "Leo H.",
    tag: "Form unlocked",
    accent: "orange",
  },
];

const accentClass = {
  lime: "text-neon-lime",
  cyan: "text-neon-cyan",
  orange: "text-neon-orange",
};

export const Testimonials = () => {
  const ref = useReveal();
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-20 sm:py-24 border-y border-white/5 bg-white/[0.015]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="reveal text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs uppercase tracking-widest text-white/70">
            <Star className="h-3.5 w-3.5 text-neon-lime" />
            Member Results
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight text-white">
            REAL ATHLETES. <span className="text-neon-lime">REAL NUMBERS.</span>
          </h2>
        </div>

        <div className="grid gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <TCard key={t.id} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

const TCard = ({ t }) => {
  const ref = useReveal();
  return (
    <Card
      ref={ref}
      data-testid="testimonial-card"
      className="reveal card-lift bg-white/[0.03] border-white/10 rounded-2xl"
    >
      <CardContent className="p-6">
        <Quote className={`h-6 w-6 ${accentClass[t.accent]}`} />
        <p className="mt-3 text-white/85 leading-relaxed" dangerouslySetInnerHTML={{ __html: t.quote }} />
        <div className="mt-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Avatar className="h-9 w-9">
              <AvatarFallback className="bg-white/10 text-white text-xs">
                {t.name.split(" ").map((p) => p[0]).join("")}
              </AvatarFallback>
            </Avatar>
            <div>
              <div className="text-sm text-white font-semibold leading-none">{t.name}</div>
              <div className="text-[11px] text-white/55 mt-1">Verified member</div>
            </div>
          </div>
          <span className={`text-[11px] font-mono-num rounded-full border px-2.5 py-1 ${accentClass[t.accent]} border-white/10 bg-white/5`}>
            {t.tag}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
